import { render } from "./ColorSizePickerComponent.vue?vue&type=template&id=0d490358"
import script from "./ColorSizePickerComponent.vue?vue&type=script&lang=js"
export * from "./ColorSizePickerComponent.vue?vue&type=script&lang=js"

import "./ColorSizePickerComponent.vue?vue&type=style&index=0&id=0d490358&lang=css"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__